{
    "coordinates": [
        40.09320539099858,
        70.18271298503566
    ],
    "tooltip": "Madygen",
    "title": "Madygen Formation",
    "country": "Kyrgyztan, Taijikistan, Uzbekistan",
    "period": "Triassic",
    "alt": "TODO"
}
